import { FC } from 'react'
import { useEmployeeWithAppraisalInviteInfo } from '../../../graphql/employee/hooks/useEmployeeWithAppraisalInviteModalInfo'
import { SkillEmployeeStatusDto } from '../../../types'
import { AppraisalInviteModal } from './AppraisalInviteModal'

interface AppraisalInviteContainerProps {
  employeeId: string
  closeModal: () => void
  updateEmployeeSkillStatus: (skillStatusData: SkillEmployeeStatusDto | null) => void
  buId?: string
  employeeSkillStatus: SkillEmployeeStatusDto | null
}

export const AppraisalInviteModalContainer: FC<AppraisalInviteContainerProps> = ({
  employeeId,
  closeModal,
  buId,
  employeeSkillStatus,
  updateEmployeeSkillStatus,
}) => {
  const { data, error, loading } = useEmployeeWithAppraisalInviteInfo(employeeId)

  return (
    <AppraisalInviteModal
      loading={loading}
      queryError={error}
      employee={data?.employeeDisplayTinyInfoByEmployeeId}
      appraisalSeason={data?.appraisalSeasonOptionByEmployeeId}
      additionalParticipantOptions={data?.nonParticipantsOptionsForEmployee}
      meetingInviteOptions={data?.meetingInviteOptionsForEmployee}
      onCancel={closeModal}
      buId={buId}
      skillStatusData={employeeSkillStatus}
      updateEmployeeSkillStatus={updateEmployeeSkillStatus}
    />
  )
}
